<template>
  <v-flex id="scroll-target"
          class="sfh-login-form background-image scrollbar scroll-style-15">
    <v-layout column>
      <v-flex  :style="styleObj">
        <v-layout row wrap v-scroll:#scroll-target="onScroll">

          <slot></slot>

        </v-layout>
      </v-flex>
    </v-layout>

  </v-flex>
</template>

<script>
  export default {
    name: 'NoScrollData',
    mounted () {
      this.scrollHeight = this.$store.getters.getAppHeight - 190
    },
    computed: {
      isCompactHeader: {
        get: function () {
          return this.$store.getters.getIsCompactHeader
        },
        set: function (val) {
          this.$store.commit('setIsCompactHeader', val)
        }
      },
      appHeight: {
        get: function () {
          return this.scrollHeight
        },
        set: function (height) {
          this.scrollHeight = height
        }
      },
      styleObj () {
        const height = this.appHeight
        return {
          'height': height + 'px!important',
          'overflow': 'auto'
        }
      }
    },
    methods: {
      onScroll (e) {
        const top = e.target.scrollTop
        if (top > 300) {
          this.isGoToTopBtn = true
          this.isCompactHeader = false
          this.appHeight = this.$store.getters.getAppHeight
        } else {
          this.isGoToTopBtn = false
          this.isCompactHeader = true
          this.appHeight = this.$store.getters.getAppHeight - 190
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .sfh-login-form{
    padding-top: 0!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/NoScrollData.vue